// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import Vue from 'vue'

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  '_c/Ele', // 查找的目录
  false, // 是否查找子目录
  /Ele[\w]+\.vue$/, // 查找文件名包含El的文件
)

// For each matching file name...
requireComponent.keys().forEach(fileName => {
  // Get the component config
  const componentConfig = requireComponent(fileName)
  // Get the PascalCase version of the component name
  const componentName = fileName
    // Remove the "./" from the beginning
    .replace(/^\.\//, '')
    // Remove the file extension from the end
    .replace(/\.\w+$/, '')

  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})

// // common 文件夹下文件直接引用name
// const commons = require.context('_c/common', false, /\.vue$/)
// commons.keys().map(item => Vue.component(commons(item).default.name, commons(item).default))